export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_INSURANCE":
      return [...state, action.payload.insurance];
    case "UPDATE_INSURANCES":
      return action.payload.insurances;
    case "DELETE_INSURANCE":
      return state.filter((insurance) => {
        return insurance.id !== action.payload.insurance.id
      });
    default:
      return state;
  }
}
